import trainRoutes from './routes'

/* @ngInject */
const trainRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(trainRoutes.index.path, {
      url: trainRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'trainCtrl',
      redirectTo: trainRoutes.home.path,
    })
    .state(trainRoutes.home.path, {
      url: trainRoutes.home.url,
      template: require('./templates/home.html'),
    })
    .state(trainRoutes.edit.path, {
      url: trainRoutes.edit.url,
      template: require('./templates/edit.html'),
    })
    .state(trainRoutes.details.path, {
      url: trainRoutes.details.url,
      template: require('./templates/details.html'),
    })
}

export default trainRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/train/train.routes.js